import { html } from 'lit';

export const settingsIcon = html`
<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
>
    <circle cx="12" cy="12" r="3.5"></circle>
    <circle cx="12" cy="12" r="7.5"></circle>
    <line x1="12" y1="2.5" x2="12" y2="5"></line>
    <line x1="12" y1="19" x2="12" y2="21.5"></line>
    <line x1="2.5" y1="12" x2="5" y2="12"></line>
    <line x1="19" y1="12" x2="21.5" y2="12"></line>
    <line x1="5.8" y1="5.8" x2="7.7" y2="7.7"></line>
    <line x1="16.3" y1="16.3" x2="18.2" y2="18.2"></line>
    <line x1="5.8" y1="18.2" x2="7.7" y2="16.3"></line>
    <line x1="16.3" y1="7.7" x2="18.2" y2="5.8"></line>
</svg>
`;
